import type { ReportCustomerDto } from './customer.dto';

/** Create vs edit report metadata form. */
export type ReportCustomerPickerMode = 'create' | 'edit';

/**
 * Customers shown on the report create/edit customer select.
 * Create lists currently-active warehouse clients only, even when older
 * reports exist. Edit also includes the saved customer so existing reports
 * stay editable after DW flips `is_currently_active`.
 * @param customers - Full customer list from the API.
 * @param mode - Report metadata form mode.
 * @param savedCustomerId - Customer already stored on the report being edited.
 * @returns Filtered options for the metadata picker.
 */
export const customersForReportMetadataPicker = (
  customers: ReportCustomerDto[],
  mode: ReportCustomerPickerMode,
  savedCustomerId?: string,
): ReportCustomerDto[] => {
  return customers.filter(customer => {
    if (customer.isCurrentlyActive !== false) {
      return true;
    }
    return mode === 'edit' && savedCustomerId === customer.id;
  });
};
